import React from 'react';
import {getIcon} from "../service/Icon";

class CategoryList extends React.Component {

    static defaultProps = {
        className: '',
        categories: [],
        onClick: () => {
        }
    }

    render() {

        const {filter} = this.props;
        return (
            <div className={'container-fluid category-grid ' + this.props.className}>
                <div className="row">
                    {this.props.categories.map(category => {
                        return (
                            <div className="col-xs-12 col-sm-6 col-md-6" key={category.category_id}>
                                <label>
                                    <img
                                        src={'/wp-content/plugins/dsz-wordpress-list/map/build/' + getIcon(category.category_slug)}
                                        width={30} alt={category.category_title}/>
                                    <input
                                        type="checkbox"
                                        value={category.category_id}
                                        onClick={this.props.onClick}
                                        checked={(filter.categories.includes(category.category_id.toString()))}
                                    /> {category.category_title}
                                </label>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

}

export default CategoryList;
